module.exports = id => `
  {
    sustainabilityPageLocations(ids: [${id}]) {
      id
      title
      teaser
      bannerImageUrl
      city
      type
      position
      employees
      responsibility
      foundedOn
      nextLocationId
      sections {
        id
        title
        text
      }
      galleryItems {
        id
        title
        description
        url
      }
      otherLocations {
        id
        title
        teaser
        teaserImageUrl
      }
    },
    sustainabilityPage {
      locations {
        id
        title
        teaser
        teaserImageUrl
        position
        city
        type
      }
    }
  }
`
